import styled from 'styled-components';

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(16, 1fr);
`;

export default Grid;
